import script from "./transfer.vue?vue&type=script&lang=ts&setup=true"
export * from "./transfer.vue?vue&type=script&lang=ts&setup=true"

import "./transfer.vue?vue&type=style&index=0&id=49acb9b8&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49acb9b8"]])

export default __exports__